import "./index.scss";
const PercentageBar = (props: {color1: string, color2: string, percentage: string}) => {
    //two percentages
    return(
        <div className="p-bar">
        <div className="outer-bar" style={{backgroundColor: props.color2}}>
            <div className="inner-bar" style={{backgroundColor: props.color1, width: props.percentage}}/>
        </div>
        <div className="labels">
            <span>0</span>
            <span>0.25</span>
            <span>0.50</span>
            <span>0.75</span>
            <span>1</span>
        </div>
    </div>
    )
}

export default PercentageBar;